import React from 'react'
import { css, cx } from '@emotion/css'
import { StyledIconProps } from '.'
import { CsXIcon } from './x-icon'

export function CsCloseIcon({
  color = 'gray030',
  size = 7,
  className,
  ...rest
}: StyledIconProps) {
  return (
    <CsXIcon
      color={color}
      size={size}
      className={cx(
        css`
          opacity: 0.7;
          cursor: pointer;
          flex-shrink: 0;
          transition: opacity 0.2s;
          &:hover {
            opacity: 1;
          }
        `,
        className
      )}
      {...rest}
    />
  )
}
